<p class="flex justify-center text-4xl md:text-2xl lg:text-4xl xl:text-4xl font-medium text-gray-600 uppercase">{{title}}</p>
